import { type VariantProps, cva } from "class-variance-authority";
import { type HTMLAttributes, forwardRef } from "react";

import { cn } from "../utils";

const badgeVariants = cva(
	"inline-flex items-center rounded border px-1.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
	{
		variants: {
			color: {
				contrast: "border-transparent bg-palette-contrast-9 text-palette-contrast-1",
				brand: "border-transparent bg-palette-brand-9 text-fixed-light-default",
				positive: "border-transparent bg-palette-positive-9 text-fixed-light-default",
				negative: "border-transparent bg-palette-negative-9 text-fixed-light-default",
				gray: "border-transparent bg-palette-gray-9 text-palette-gray-1",
			},
		},
		defaultVariants: {
			color: "contrast",
		},
	}
);

export interface BadgeProps
	extends Omit<HTMLAttributes<HTMLDivElement>, "color">,
		VariantProps<typeof badgeVariants> {}

const Badge = forwardRef<HTMLDivElement, BadgeProps>(({ className, color, ...props }, ref) => (
	<div ref={ref} className={cn(badgeVariants({ color }), className)} {...props} />
));
Badge.displayName = "Badge";

export { Badge, badgeVariants };
